<template>
  <a
    v-if="!this.$slots.items"
    :class="['v-navbar-navigation-item', { 'v-navbar-navigation-item--active': active }]"
    v-on="$listeners"
  >
    <slot name="default"></slot>
  </a>
  <v-navbar-menu-item
    v-else
    v-on="$listeners"
    v-bind="$attrs"
    :active="active"
    navigation
  >
    <slot name="default"></slot>
    <template v-slot:items>
        <slot name="items"></slot>
    </template>
  </v-navbar-menu-item>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../sass/component.scss";

.v-navbar-navigation-item {
  white-space: nowrap;
  text-decoration: none;
  color: theme-color("dark");
  padding: 10px 11px;
  margin: 0;
  font-size: 0.875rem;
  /* outline: 0; */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  @include media-breakpoint-up(md) {
    font-size: 1rem;
    padding: 2px $spacer 0 $spacer;
  }

  @include media-breakpoint-up(lg) {
    margin: 0 $spacer * 0.25;
  }

  &:active,
  &:hover,
  &--active {
    color: theme-color("primary");
  }

  &--active {
    font-weight: bold;
  }
}
</style>
